<div *ngIf="order" class="container">
  <client-detail-expansion *ngIf="loggedIn$ | async"
    [clientOrder]="order"></client-detail-expansion>
  <div *ngIf="order.order.type !== 'RETAILTRANSACTION'" class="title">{{ 'orderDetail.title' | translate }}</div>
  <order-detail *ngIf="order.order && order.order.type !== 'RETAILTRANSACTION'" [order]="order.order"> </order-detail>
  <div *ngIf="order.order.type !== 'ECOMMORDER'">
    <div class="title">{{ 'transactionDetail.title' | translate }}</div>
    <div [ngClass]="{'object-separator': !isFirst}" *ngFor="let transaction of transactions; first as isFirst">
      <transaction-detail [transaction]="transaction"></transaction-detail>
    </div>
  </div>
</div>
